<template>
  <Dialog v-model="visible" :variant="['claim-success', 'claim-all-success'].includes(props.type) ? 'panel' : 'plain'" :title="title" :closable="true">
    <div class="result-dialog" :class="[isMobile ? 'mobile' : 'pc', `result-dialog--${props.type}`]">
      <div class="result-text">{{ content }}</div>
      <div class="result-rewards" v-if="rewards.length">
        <div class="result-prop" v-for="(reward, index) in rewards" :key="index">
          <div class="prop-icon">
            <img v-if="!iconErrors[index]" :src="getPropIcon(reward.propId)" :alt="getPropName(t, reward)" @error="iconErrors[index] = true" />
            <span v-else class="icon-fallback">{{ getPropName(t, reward).slice(0, 1) }}</span>
          </div>
          <div class="prop-name">{{ getPropName(t, reward) }}<span class="prop-count">*{{ reward.propCount }}</span></div>
        </div>
      </div>
      <div class="dialog-actions" v-if="!['claim-success', 'claim-all-success'].includes(props.type)">
        <div
          class="action-btn plain"
          v-if="props.type === 'not-enough'"
          @click="visible = false"
        >{{ $t('novShopping.common.cancel') }}</div>
        <div
          class="action-btn primary"
          v-if="props.type === 'not-enough'"
          @click="$emit('top-up')"
        >{{ $t('novShopping.milestone.topUp') }}</div>
        <div
          class="action-btn primary"
          v-else
          @click="visible = false"
        >{{ $t('novShopping.common.confirm') }}</div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, ref, watch, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../Dialog/index.vue'
import { isMobile } from '@/utils'
import { getPropIcon, getPropName } from '../../utils/prop'

const props = defineProps({
  rewardList: { type: Array, default: () => [] },
  modelValue: {
    type: Boolean,
    default: false,
  },
  // success-兑换成功 | expired-道具已过期 | not-enough-购物券不足 | claim-success-领取成功 | claim-all-success-移动端一键领取成功
  type: {
    type: String,
    default: 'success',
  },
  // 成功时展示的道具 { propId, propName, propCount }
  prop: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue', 'top-up', 'open-record'])

const { t } = useI18n()
const iconErrors = ref({})
const rewards = computed(() => {
  return props.type === 'success' && props.prop ? [props.prop] : []
})
watch(() => [props.modelValue, props.prop, props.rewardList], () => { iconErrors.value = {} })

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const title = computed(() => {
  if (props.type === 'not-enough') return t('novShopping.goods.notEnoughVoucher')
  if (props.type === 'expired') return t('novShopping.goods.expired')
  if (['claim-success', 'claim-all-success'].includes(props.type)) return t('novShopping.milestone.claimSuccess')
  return ''
})

const content = computed(() => {
  if (props.type === 'not-enough') return t('novShopping.goods.notEnoughDesc')
  if (props.type === 'expired') return t('novShopping.goods.expired')
  if (['claim-success', 'claim-all-success'].includes(props.type)) return t('novShopping.milestone.claimSuccessDesc')
  return t('novShopping.goods.success')
})
</script>

<style lang="less" scoped>
@import '../../styles/tokens.less';
.result-dialog {
  .result-rewards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    width: 100%;
    max-height: 42vh;
    overflow-y: auto;
  }
  .result-prop { width: 180px; flex: none; text-align: center; }

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  .result-text {
    text-align: center;
    font-size: 26px;
    line-height: 1.6;
    color: #4a3f2f;
  }

  .result-prop {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    .prop-icon {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background: #f3f0e9;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .icon-fallback {
        font-size: 48px;
        color: #b9a98c;
      }
    }

    .prop-name {
      font-size: 24px;
      color: #4a3f2f;
    }
  }
}
</style>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
